module.exports = __webpack_public_path__ + "static/media/super_pope.32a9cc65.jpeg";